<msc-question *ngIf="question.type !== 'category'" [question]="question" [questionSession]="questionSession" [exercise]="exercise" (nextEvent)="nextQuestion()" [sectionContent]="sectionContent"></msc-question>

<msc-flash-cards-question *ngIf="question.type === 'category'" [question]="question" [exercise]="exercise" [questionSession]="questionSession"></msc-flash-cards-question>
